import { findClosest } from '@fi-shared/utils/closest';

export function eventFindInPath(
    event: {
        target: any;
    },
    selector: string,
    stopSelector?: string,
) {
    return findClosest(event.target, selector, stopSelector);
}
